export default "__VITE_ASSET__6712b1b0__"